import * as types from "../types/orderManagementListing.types";
import moment from "moment";

const initialState = {
  initialData: [],
  initialLoading: false,
  initialPagination: [],
  initialFilter: {
    page: 1,
    limit: 10,
    date: [moment(), moment()],
    sort: "desc",
  },
};

const OrderManagementListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LIST_DATA:
      return { ...state, initialData: action.payload };
    case types.SET_LOADING_DATA:
      return { ...state, initialLoading: action.payload };
    case types.SET_LIST_PAGINATION:
      return { ...state, initialPagination: action.payload };
    case types.SET_LIST_FILTER:
      return { ...state, initialFilter: action.payload };
    case types.RESET_REDUCER:
      return {
        ...state,
        initialData: [],
        initialLoading: false,
        initialPagination: [],
        initialFilter: initialState.initialFilter,
      };
    default:
      return state;
  }
};
export default OrderManagementListingReducer;
